<template>
  <div class="page">
    <section>
      <div class="content">
        <IntroSection/>
      </div>
    </section>
    <section class="profile">
      <div class="content">
        <ProfileSection/>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
import Footer from '../components/Footer';
import IntroSection from '../components/IntroSection';
import ProfileSection from '../components/ProfileSection';

export default {
  name: 'HomePage',
  components: {
    Footer,
    IntroSection,
    ProfileSection,
  }
}
</script>

<style scoped>
section.profile {
  background: #F2BF5C;
}

.content {
  padding: 1rem;
  max-width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
}

@media screen and (min-width: 480px) {
  .content {
    padding: 2rem 5%;
  }
}

@media screen and (min-width: 1024px) {
  .content {
    padding: 2rem 10%;
    min-width: 1024px;
  }
}

@media screen and (min-width: 1440px) {
  .content {
    box-sizing: content-box;
    padding: 2rem 0;
    min-height: calc(100vh - 4rem);
    width: 1024px;
    margin: 0 auto;
  }
}
</style>
